import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { CALENDAR_LOCALES } from './calendar-locales';

@Injectable({ providedIn: 'root' })
export class PrimeNGI18nService {
  private readonly primeNG = inject(PrimeNG);
  private readonly translateService = inject(TranslateService);

  constructor() {
    this.apply(this.translateService.currentLang || this.translateService.getDefaultLang() || 'en');
    this.translateService.onLangChange.pipe(takeUntilDestroyed()).subscribe(e => this.apply(e.lang));
  }

  private apply(lang: string) {
    this.primeNG.setTranslation(
      CALENDAR_LOCALES[lang as keyof typeof CALENDAR_LOCALES] ?? CALENDAR_LOCALES.en,
    );
  }
}
